"use client";

import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useActionState, useEffect } from "react";
import { toast } from "sonner";

import { Form } from "@/components/form";
import { SubmitButton } from "@/components/submit-button";

import { login, type LoginActionState } from "../actions";

export default function Login() {
  const [state, formAction] = useActionState<LoginActionState, FormData>(
    login,
    { status: "idle" },
  );
  const router = useRouter();

  useEffect(() => {
    if (state.status === "success") {
      router.push("/admin/dashboard");
    } else if (state.status === "invalid_credentials") {
      toast.error("User doesn't exist or wrong password");
    } else if (state.status === "error") {
      toast.error("Something went wrong");
    }
  }, [state, router]);

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-gray-50">
      <div className="z-10 w-full max-w-md overflow-hidden rounded-2xl border border-gray-100 shadow-xl">
        <div className="flex flex-col items-center justify-center space-y-3 border-b border-gray-200 bg-white px-4 py-6 pt-8 text-center sm:px-16">
          <Image
            src="/img/drtimmerluibrand.png"
            alt="DGP Plattform Logo"
            className="h-12 invert object-contain mb-4"
            width={258}
            height={48}
            priority={true}
          />
          <h3 className="text-xl font-semibold">Login</h3>
          <p className="text-sm text-gray-500">
            Melden sie sich mit email und Passwort an.
          </p>
        </div>
        <Form action={formAction}>
          <SubmitButton>Login</SubmitButton>
          <p className="text-center text-sm text-gray-600">
            <Link
              href="/forgot-password"
              className="font-semibold text-gray-800"
            >
              Passwort vergessen?
            </Link>
          </p>
          <p className="text-center text-sm text-gray-600">
            {"Sie haben noch kein Konto? "}
            <Link href="/register" className="font-semibold text-gray-800">
              Hier
            </Link>
            {" registrieren."}
          </p>
        </Form>
      </div>
    </div>
  );
}
